import { Box, Button } from "@mui/material";
import Lottie from "lottie-react";
import { connect } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "../../packages";
import { RootState, useAppDispatch } from "../../redux/store";
import { Subscribe } from "../SignUpModule/store/signup.types";
import { getPaymentbyIdMiddleWare } from "../SignUpModule/store/signupMiddleware";
import { setLoader } from "../../common/store/commonReducer";
import { getUserMiddleWare } from "../ProfileModule/store/profileMiddleware";
import { routes } from "../../routes/routesPath";

const mapStateToProps = (state: RootState) => {
  const { subscribeReducers, loaderReducers } = state;
  return {
    data: subscribeReducers.data,
    isLoader: loaderReducers.isLoader,
  };
};

type Props = {
  open: boolean;
  data: Subscribe;
  close: () => void;
  isLoader: boolean;
  isNewUser: boolean;
};

const PaymentProgrees = ({ open, close, data, isLoader, isNewUser }: Props) => {
  const dispatch = useAppDispatch();
  const [payamentData, setPaymentData] = useState<any>({});
  const navigate = useNavigate();

  const checkoutSessionStatus =
    payamentData?.userPaymentDetails?.checkoutSessionStatus;
  const paymentStatus = payamentData?.userPaymentDetails?.paymentStatus;

  const success =
    paymentStatus === "paid" && checkoutSessionStatus === "complete";
  let error = false;

  if (
    (paymentStatus === "unpaid" && checkoutSessionStatus === "complete") ||
    (paymentStatus === "unpaid" && checkoutSessionStatus === "expired")
  ) {
    error = true;
  } else if (paymentStatus === "unpaid" && checkoutSessionStatus === "open") {
    error = true;
  }

  const handleCall = () => {
    dispatch(getPaymentbyIdMiddleWare({ id: data?.paymentId })).then((res) => {
      setPaymentData(res.payload);
    });
  };

  useEffect(() => {
    if (open && !success && !error) {
      const interval = setInterval(() => {
        handleCall();
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [open, success, error]);

  if (success) {
    return (
      <Modal open={open} close={() => {}}>
        <Box>
          <Lottie
            animationData={require("../../animations/paymentSuccess.json")}
            loop={true}
          />
          <Button
            size="large"
            sx={{ textTransform: "capitalize" }}
            fullWidth
            color="success"
            variant="contained"
            disabled={isLoader}
            onClick={() => {
              dispatch(setLoader(true));
              dispatch(getUserMiddleWare()).finally(() => {
                navigate(routes.HOME);
                close();
                dispatch(setLoader(false));
              });
            }}
          >
            Go Home
          </Button>
        </Box>
      </Modal>
    );
  }
  if (error) {
    return (
      <Modal open={open} close={() => {}}>
        <Box>
          <Lottie
            animationData={require("../../animations/paymentFail.json")}
            loop={true}
          />
          <Button
            size="large"
            sx={{ textTransform: "capitalize" }}
            fullWidth
            color="error"
            variant="contained"
            onClick={close}
          >
            Try Again
          </Button>
        </Box>
      </Modal>
    );
  }

  return (
    <Modal variant="transparent" open={open} close={() => {}}>
      <Lottie
        animationData={require("../../animations/paymentLoader.json")}
        loop={true}
      />
    </Modal>
  );
};

export default connect(mapStateToProps)(PaymentProgrees);
